// extracted by mini-css-extract-plugin
module.exports = {"root":"NavDropdown_root__uZvd6","root--open":"NavDropdown_root--open__T_MGq","root--simpleNav":"NavDropdown_root--simpleNav__67ndx","rotation":"NavDropdown_rotation__X6hC5"};